module.exports = __webpack_public_path__ + "fonts/8c049af7962e2f8a016e40108555be35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_white.svg
// module id = 2027
// module chunks = 0